// extracted by mini-css-extract-plugin
export var headline = "projects-module--headline--I9nW1";
export var projects = "projects-module--projects--WS691";